import {t} from "@lingui/core/macro";
import {useEffect} from "react";
import {useBlocker} from "react-router-dom-v5-compat";
import type {Editor} from "slate";

import {hasUnsavedChanges} from "../slate/helpers/insertion-helpers.ts";

/**
 * This hook detects (and asks for confirmation) when the
 * browser window is going to close/reload/change URL and the given editor
 * has unsaved changes.
 *
 * WARNING: this hook depends on the RRv6 API.  It is not compatible with
 * RRv5.
 */
export default function useRRv6CheckForUnsavedChanges(
    editor: Editor | null,
    viewOnly: boolean,
) {
    const blocker = useBlocker(({currentLocation, nextLocation}) => {
        if (!editor || viewOnly) {
            return;
        }
        return (hasUnsavedChanges(editor) &&
            currentLocation.pathname !== nextLocation.pathname) as any;
    });

    useEffect(() => {
        if (blocker.state === "blocked") {
            // eslint-disable-next-line no-alert -- porting from old code.
            window?.alert?.(
                t`Are you sure you want to leave? Your document won't be saved unless you click 'Print' or 'Export'.`,
            );
        }
    }, [blocker.state]);
}
